<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false" class="center" width="500px">

    <div class="wrapper" v-html="$t('skirental.measure-foot-text')"></div>

    <div class="border">
      <img src="https://static.booking.branasgruppen.se/static/svg/fot-mata.svg" />
    </div>

    <div v-if="showDinText" v-html="$t('skirental.measure-foot-din')" style="margin-top:10px;"></div>

  </Modal>
</template>

<script>
import API from '@/classes/API';

import Modal from '@/components/components/Modal';
import { mapMutations } from 'vuex';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  async mounted() {
    const store = Object.assign({}, this.$store.state);

    const { show } = await API.frontendHelper(`skirental/din-scale?index=${this.params.index}`, store);

    this.showDinText = show;
  },
  data() {
    return {
      showDinText: false,
    };
  },
  computed: {
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

b
  font-size 14px
  font-weight bold
  letter-spacing 0.4px
  text-align center
  color #262626

.wrapper
  max-width 337px

p
  font-size 14px
  font-weight 300
  line-height 1.3
  text-align center
  color #262626
  max-width 100%
  margin-top 5px
  margin-bottom 15px

img
  width 128px
  height 167px

.border
  border-top solid 2px #bfd9e1
  border-bottom solid 2px #bfd9e1
</style>



// WEBPACK FOOTER //
// SkiRentalFoot.vue?5561e394